/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { BookingsListResponse } from '../../models/bookings-list-response';

export interface BookingControllerMyBookings$Params {
  from_date?: string;
  to_date?: string;
  identifier?: string;
  query?: string;
  user?: string;
  status_id?: number;
  limit: number;
  skip: number;
}

export function bookingControllerMyBookings(http: HttpClient, rootUrl: string, params: BookingControllerMyBookings$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: BookingsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerMyBookings.PATH, 'get');
  if (params) {
    rb.query('from_date', params.from_date, {});
    rb.query('to_date', params.to_date, {});
    rb.query('identifier', params.identifier, {});
    rb.query('query', params.query, {});
    rb.query('user', params.user, {});
    rb.query('status_id', params.status_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: BookingsListResponse;
      }>;
    })
  );
}

bookingControllerMyBookings.PATH = '/booking/my';
